import type {
	TextUmbBlockElementModel,
	TextUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { Text } from "#/_packages/umbrella/features/text/components/text";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import {
	tryGetAlignment,
	tryGetAnimationScrollType,
	tryGetReadWidthLength,
} from "#/_packages/umbrella/utils";

type ITextBlockProps = BlockItemProps & {
	content: TextUmbBlockElementModel;
	settings?: TextUmbBlockSettingsElementModel;
};

export default function TextUmbBlock({
	className,
	content,
	settings,
}: ITextBlockProps) {
	const settingsProperties = settings?.properties;

	return (
		<Text
			inlineField="body"
			inlineElementKey={content.id}
			id={settingsProperties?.generatedId}
			className={className}
			animationHoverType={settingsProperties?.animationHoverType ?? []}
			alignmentHorizontal={
				settingsProperties?.alignmentHorizontal
					? tryGetAlignment(settingsProperties.alignmentHorizontal)
					: undefined
			}
			alignmentSelfVertical={
				settingsProperties?.alignmentSelfVertical
					? tryGetAlignment(settingsProperties.alignmentSelfVertical)
					: undefined
			}
			animationScrollType={tryGetAnimationScrollType(
				settingsProperties?.animationScrollType,
			)}
			readWidthLength={tryGetReadWidthLength(
				settingsProperties?.readWidthLengthPicker,
			)}
			readWidthToggle={settingsProperties?.readWidthToggle ?? false}
			htmlBody={content.properties?.body?.markup}
		/>
	);
}
